<template>
  <div class="col-lg-12 page" ref="pageBody" >
      <div class="page-help-corner">
        <help-icon help-id="cda" title="Help for CDAs" />
      </div>
      <div class="row file-upload-controls">
        <file-list :fileType="cdaFileType" :fileList="cdaList" @change="onCdaSelected" :selectedItem="selectedCda" class="col-md-6 col-sm-12 col-12 "></file-list>
        <file-upload :fileType="cdaFileType"></file-upload>
      </div>
      <!-- Not the same as a chart with no C-CDAs: the list itself could not be
           read (stores/chartCdas.js). -->
      <p v-if="cdaListLoadFailed" class="list-load-failed" role="alert" data-test="cda-list-load-failed">
        This chart's CDAs could not be loaded. Reload the page to try again.
      </p>
      <div class="void-filler-cda" v-if="selectedCda === undefined">
        <h1 class="filler-icon"><font-awesome-icon :icon="['fas', 'search-plus']" /></h1>
        <p>Select or upload a CDA to view its contents</p>
      </div>
      <cda-content-body v-else :index="selectedCda" :type="selectedType" :id="selectedId"/>
  </div>
</template>
<script>
import router from '@/router/index';
import { mapActions, mapGetters } from 'vuex';
import { INIT_NO_OP_NUM, CDA_FILE_TYPE } from '@/config';
import FileListDropdown from '@/components/includes/file/FileListDropdown';
import FileUpload from '@/components/includes/file/FileUpload';
import CdaContentBody from '@/components/includes/cda/CdaContentBody';
import { CdasNavigation } from '@/store/modules/fsm/messages';
import { 
  requestVitalSignsCodes
} from '@/api/sessionApi';
import HelpIcon from '@/components/help/HelpIcon.vue';

export default {
  name: 'cda-page',
  data () {
    return {
      cdaFileType: CDA_FILE_TYPE,
      INIT_NO_OP_NUM
    };
  },
  props: {
    selectedCda: {
      type: Number,
      required: false
    },
    selectedType: {
      type: String,
      required: false
    },
    selectedId: {
      type: Number,
      required: false
    }
  },
  components: {
    'file-list': FileListDropdown,
    'file-upload': FileUpload,
    'cda-content-body': CdaContentBody,
    HelpIcon,
  },
  methods: {
    onCdaSelected(selectedCda) {
      const rawIndex = selectedCda && selectedCda.target
        ? selectedCda.target.value
        : selectedCda;
      const parsedIndex = Number(rawIndex);
      if (!Number.isFinite(parsedIndex)) {
        return;
      }
      router.push({
        name: CdasNavigation,
        params: {
          selectedCda: parsedIndex
        }
      });
    },
    ...mapActions('login', [
      'updateApplicationModel'
    ]),
    ...mapActions('login/watch', [
      'setVitalSignCodes'
    ])
  },
  computed: {
    ...mapGetters('login/cda', {
      cdaList: 'getCdaList',
      cdaId: 'getCdaId',
      cdaListLoadFailed: 'cdaListLoadFailed',
    }),
    ...mapGetters('login/watch', {
      vitalCcds: 'getVitalSignCodes'
    }),
  },
  mounted() {
    // Cached getAllData() can omit CDAs; rebuild so the dropdown matches the database.
    this.updateApplicationModel({ rebuild: true });

    // Always refresh vital-sign codes on mount. login.watch is persisted to
    // sessionStorage (see store/index.js), so a stale vitalSignCodes list can
    // survive a page reload and mis-sort measures between the Vitals and Labs
    // sections. Refetching keeps the split in sync with LA_labccd.
    requestVitalSignsCodes()
    .then((vitalSignCodes) => {
      this.setVitalSignCodes(vitalSignCodes);
    })
    .catch((err) => {
      console.error(err);
    });
  },
  beforeDestroy() {
    delete this.cdaFileType;
    this.cdaFileType = null;
    delete this.INIT_NO_OP_NUM;
    this.INIT_NO_OP_NUM = null; 
  }
}
</script>

<style lang="scss">
  .list-load-failed {
    color: #b00020;
    margin: 0.5rem 0 0;
  }

  .page-help-corner {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.35rem;
  }

  .void-filler-cda {
    color: gray;
    text-align: center;
    font-size: 1.5rem;
    margin-top: 2.0rem;

    .filler-icon {
      font-size: 2.5rem;
    }
  }
</style>
